module.exports = __webpack_public_path__ + "assets/images/edge530-f80a4c5838222fe03f5516aed00df4d9.jpg";